import {
  TablePage,
  // AddPage,
  // EditPage,
  // ViewPage,
} from 'src/views/nbstransaction'
import pathMap from 'src/paths/pathMap'

class NbsTransactionRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.NBS_TRANSACTION_LIST_VIEW,
        component: TablePage
      }
      // {
      //   exact: true,
      //   path: pathMap.NBS_TRANSACTION_ADD_VIEW,
      //   component: AddPage
      // },
      // {
      //   exact: true,
      //   path: pathMap.NBS_TRANSACTION_EDIT_VIEW,
      //   component: EditPage
      // },
      // {
      //   exact: true,
      //   path: pathMap.NBS_TRANSACTION_DETAILS_VIEW,
      //   component: ViewPage
      // }
    ]
  }
}

export default NbsTransactionRoute
